import { observable } from "mobx";
import { Type } from "class-transformer";
import SalespointResponse from "./salespointResponse";
import ShutdownIntervalResponse from "./shutdownIntervalResponse";
import TradingPlaceType from "./tradingPlaceType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class TradingPlaceDetailResponse {
  /**
   * Trading place ID.
   */
  id!: string;

  /**
   * Trading place name.
   */
  @observable
  name!: string;

  @observable
  type!: TradingPlaceType;

  /**
   * Indicates whether the trading place is visible and purchase is allowed.
   */
  @observable
  isAvailable!: boolean;

  /**
   * Location latitude.
   */
  @observable
  latitude?: number;

  /**
   * Location longitude.
   */
  @observable
  longitude?: number;

  @observable
  @Type(() => SalespointResponse)
  salespoint?: SalespointResponse;

  /**
   * Trading place shutdowns.
   */
  @observable
  @Type(() => ShutdownIntervalResponse)
  shutdowns?: ShutdownIntervalResponse[];
}
